import { z } from 'zod';

export const TAIGA_PREFIX = 'taiga';

const ZodTaigaIdRegex = z.string().regex(new RegExp(`^${TAIGA_PREFIX}_`));

export const ZodTaigaId = ZodTaigaIdRegex.transform((taigaId, ctx) => {
  try {
    return normalizeURIComponent(taigaId);
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: `Invalid taiga ID: ${taigaId}`,
      fatal: true,
    });
    return z.NEVER;
  }
}).meta({ override: { type: 'string' } });

export type TaigaId = z.TypeOf<typeof ZodTaigaId>;

export const ZodTaigaIdUriEncoded = ZodTaigaIdRegex.transform((taigaId) => {
  return decodeURIComponent(taigaId);
}).meta({ override: { type: 'string' } });

export type TaigaIdUriEncoded = z.TypeOf<typeof ZodTaigaIdUriEncoded>;

export function normalizeURIComponent(str: string): string {
  // Try to decode it
  const decoded = decodeURIComponent(str);
  // If re-encoding matches the original, assume it was encoded
  if (encodeURIComponent(decoded) === str) {
    return decoded;
  }

  return encodeURIComponent(str);
}
